import { PORTAL_VIEW_CLAIM, PORTAL_VIEW_RETAIL } from '../../_config/portal-view';

export const VOUCHER_DEMO_STORAGE_KEY = 'vb-voucher-demo-mode';

export const VOUCHER_DEMO_ACCOUNT_NAME = 'Pacific Crest Business Park';
export const VOUCHER_DEMO_MARKET_NAME = 'Los Angeles';
export const VOUCHER_DEMO_PARTNER_NAME = 'Canteen';
export const VOUCHER_DEMO_CREATED_BY = 'Alex Davis';
export const VOUCHER_DEMO_VIEW_ROLE = 'campusadmin';

export const VOUCHER_DEMO_CAMPUS_ID = '91001';
export const VOUCHER_DEMO_CLIENT_ID = '91002';
export const VOUCHER_DEMO_DISTI_ID = '91003';
export const VOUCHER_DEMO_MARKET_ID = '91004';
export const VOUCHER_DEMO_MACHINE_ID = 'VB-PC-01';
export const VOUCHER_DEMO_MACHINE_NAME = 'Lobby';

export function applyVoucherDemoUserAttributes(
	userAttr: Record<string, unknown>
): Record<string, unknown> {
	return {
		...userAttr,
		'custom:role': VOUCHER_DEMO_VIEW_ROLE,
		[PORTAL_VIEW_CLAIM]: PORTAL_VIEW_RETAIL,
		'custom:campus_id': VOUCHER_DEMO_CAMPUS_ID,
		'custom:client_id': VOUCHER_DEMO_CLIENT_ID,
		'custom:disti_id': VOUCHER_DEMO_DISTI_ID,
		'custom:market_id': VOUCHER_DEMO_MARKET_ID
	};
}

export const VOUCHER_DEMO_PURCHASED_COUNT = 50;
export const VOUCHER_DEMO_DELTA_COUNT = 25;
export const VOUCHER_DEMO_MAKE_GOOD_COUNT = 3;
export const VOUCHER_DEMO_PURCHASED_REDEEMED = 18;
export const VOUCHER_DEMO_DELTA_REDEEMED = 8;
export const VOUCHER_DEMO_MAKE_GOOD_REDEEMED = 2;

export const VOUCHER_DEMO_UNIT_PRICE_CENTS = 400;
export const VOUCHER_DEMO_DOCUMENT_PREFIX = 'demo://voucher/';
export const VOUCHER_DEMO_DELTA_INVOICE_URL = VOUCHER_DEMO_DOCUMENT_PREFIX + 'invoice/delta';
export const VOUCHER_DEMO_PURCHASE_RECEIPT_URL = VOUCHER_DEMO_DOCUMENT_PREFIX + 'receipt/purchased';

// Public refs match dashboard-server Crockford conventions: VO-/VP- + 8 chars
// from 0123456789ABCDEFGHJKMNPQRSTVWXYZ (no I, L, O, U).
export const VOUCHER_DEMO_PURCHASED_PACK_REF = 'VP-7K3M9Q2X';
export const VOUCHER_DEMO_PURCHASED_ORDER_REF = 'VO-4N8R2W6Y';
export const VOUCHER_DEMO_DELTA_PACK_REF = 'VP-9C2H6T4P';
export const VOUCHER_DEMO_DELTA_ORDER_REF = 'VO-1R5K8N3W';
export const VOUCHER_DEMO_MAKE_GOOD_PACK_REFS = ['VP-3H7J2M9Q', 'VP-6T4P8C1R', 'VP-2W5N9K7H'];

export const VOUCHER_DEMO_CHECKOUT_DISABLED_MESSAGE =
	'Checkout is disabled in demo mode. Use Overview and Orders to walk through the account.';
